import gql from 'graphql-tag';
import graphqlClient from '@shared/graphql/client';

export class SeasonService {
  static async update(id, data, manage) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation SEASON_UPDATE(
          $id: String!
          $data: SeasonInput!
          $manage: ManageInput! 
        ) {
          seasonUpdate(id: $id, data: $data, manage: $manage) {
            id
          }
        }
      `,

      variables: {
        id,
        data,
        manage
      },
    });

    return response.data.seasonUpdate;
  }

  static async destroyAll(ids, manage) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation SEASON_DESTROY($ids: [String!]!
                               $manage: ManageInput!) {
          seasonDestroy(ids: $ids,  manage: $manage)
        }
      `,

      variables: {
        ids,
        manage,
      },
    });

    return response.data.seasonDestroy;
  }

  static async create(data, manage) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation SEASON_CREATE($data: SeasonInput! $manage: ManageInput!) {
          seasonCreate(data: $data,  manage: $manage) {
            id
          }
        }
      `,

      variables: {
        data,
        manage
      },
    });

    return response.data.seasonCreate;
  }

  static async import(values, importHash, manage) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation SEASON_IMPORT(
          $data: SeasonInput!
          $importHash: String!
          $manage: ManageInput!
        ) {
          seasonImport(data: $data, importHash: $importHash,  manage: $manage)
        }
      `,

      variables: {
        data: values,
        importHash,
        manage,
      },
    });

    return response.data.seasonImport;
  }

  static async find(id, manage) {
    const response = await graphqlClient.query({
      query: gql`
        query SEASON_FIND($id: String! $manage: ManageInput!) {
          seasonFind(id: $id,  manage: $manage) {
            id
            description
            name
            createdAt
            updatedAt
          }
        }
      `,

      variables: {
        id,
        manage
      },
    });

    return response.data.seasonFind;
  }

  static async list(filter, orderBy, limit, offset, manage) {
    const response = await graphqlClient.query({
      query: gql`
        query SEASON_LIST(
          $filter: SeasonFilterInput
          $orderBy: SeasonOrderByEnum
          $limit: Int
          $offset: Int
          $manage: ManageInput!
        ) {
          seasonList(
            filter: $filter
            orderBy: $orderBy
            limit: $limit
            offset: $offset
            manage: $manage
          ) {
            count
            rows {
              id
              name
              updatedAt
              createdAt
            }
          }
        }
      `,

      variables: {
        filter,
        orderBy,
        limit,
        offset,
        manage,
      },
    });

    return response.data.seasonList;
  }

  static async listAutocomplete(query, limit, manage) {
    const response = await graphqlClient.query({
      query: gql`
        query SEASON_AUTOCOMPLETE(
          $query: String
          $limit: Int
          $manage: ManageInput!
        ) {
          seasonAutocomplete(query: $query, limit: $limit,  manage: $manage) {
            id
            label
          }
        }
      `,

      variables: {
        query,
        limit,
        manage,
      },
    });

    return response.data.seasonAutocomplete;
  }
}
